import React from 'react';
import { Typography, Box, Link } from '@mui/material';

export default function NetersFlowDash() {

return (
    <>
        <Box sx={{display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',}}>
            <Typography zIndex={'1'}>
                <Link href='./home' underline="none">Home </Link> 
                | <Link href='./details' underline="none">Details </Link>
                | <Link href='./alerts' underline="none">Alerts </Link>  
                | <Link href='./stats' underline="none">Stats </Link>   
            </Typography>
        </Box>  
    </>
)
}